import React from 'react';
import PropTypes from 'prop-types';
import Geosuggest from 'react-geosuggest';
import { useTranslation } from 'utils/modifiedTranslation';

import Card from '../Card';
import useStyles from './styles';
import InputFieldContainer from '../InputFieldContainer';

const CustomGeoSuggestField = (props) => {
  const {
    label,
    helperText,
    labelClassName,
    helperTextClassName,
    isRequired,
    rootClassName,
    inputClassName,
    initialValue,
    onChange,
    onType,
    placeholder,
    inputRef,
  } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Card className={`${classes.root} ${rootClassName}`}>
      <InputFieldContainer
        label={label}
        helperText={helperText}
        labelClassName={labelClassName}
        helperTextClassName={helperTextClassName}
        isRequired={isRequired}
      >
        <Geosuggest
          ref={inputRef}
          inputClassName={inputClassName}
          initialValue={t(initialValue) || ''}
          onSuggestSelect={onChange}
          onChange={onType}
          autoComplete="off"
          country={['us', 'ca', 'il', 'tr']}
          placeholder={t(placeholder)}
        />
      </InputFieldContainer>
    </Card>
  );
};

CustomGeoSuggestField.propTypes = {
  label: PropTypes.string,
  helperText: PropTypes.string,
  labelClassName: PropTypes.string,
  isRequired: PropTypes.bool,
  rootClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  helperTextClassName: PropTypes.string,
  initialValue: PropTypes.string,
  onChange: PropTypes.func,
  onType: PropTypes.func,
  placeholder: PropTypes.string,
  // Geosuggest instance
  inputRef: PropTypes.object,
};

CustomGeoSuggestField.defaultProps = {
  placeholder: 'change_location.geo_suggest.placeholder',
  inputClassName: '',
  initialValue: '',
};

export default CustomGeoSuggestField;
